export default "__VITE_ASSET__b4ac5c21__"